import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classes from "./XclinicDuration.module.sass";

function XclinicDuration(props) {
  const { seconds, label } = props;

  return (
    <div className={classes.repetitions}>
      <div className={classes.label}>{label}</div>
      <div style={{ top: 10 + 'px' }} className="text-center pt-3">
        <div className={classes.done}>{`${seconds} sec.`}</div>
      </div>
    </div>
  );
}

XclinicDuration.propTypes = {
  label: PropTypes.string,
  seconds: PropTypes.number,
};

XclinicDuration.defaultProps = {
  label: "",
  seconds: 0,
};

export default XclinicDuration;
